import React from 'react';
import { useState, useContext, useEffect } from 'react';
import { SCOPES } from '../../../config/permissions-map';
import * as Utilities from '../../../Components/Utils/Utils';
import PermissionsGate from '../../../api/PermissionsGate';
import { Unauthorized } from '../../Global/unauthorized';
import { registerLocale } from 'react-datepicker';
import es from "date-fns/locale/es";
// import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import * as Api from '../../../api/Api';
import { useGetToken } from '../../../Hooks/CustomHooks';
import BitacoraEvento_Agregar from './BitacoraEvento_Agregar';
import Modal from 'react-bootstrap/Modal';
import ChartFromServer from '../../../Components/Charts/ChartFromServer';
import { PageTitle } from '../../../../_metronic/layout/core';
import makeAnimated from 'react-select/animated';
import Select from 'react-select';
import DatePicker from "react-date-picker"
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';


export default function BitacoraEventos({ title }) {

    const d = new Date();
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();
    const [date1, setDate1] = useState(new Date(year, month - 6, day));
    let dateFormated = ("0" + date1.getDate()).slice(-2) + "/" + ("0" + (date1.getMonth() + 1)).slice(-2) + "/" + date1.getFullYear();


    const [date2, setDate2] = useState(new Date());
    let dateFormated2 = ("0" + date2.getDate()).slice(-2) + "/" + ("0" + (date2.getMonth() + 1)).slice(-2) + "/" + date2.getFullYear();

    const token = useGetToken();
    registerLocale("es", es);

    const [enableQuery, setEnableQuery] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [guardadoExitoso, setGuardadoExitoso] = useState(false);

    const [dataAux, setDataAux] = useState({ "ventaAcumlada": 0 });

    const [unidadEconomica, setUnidadEconomica] = useState(Utilities.getListUnidadesEconomicas(true).list[0]);
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas(true);

    function onAfterGuardar(action) {
        setShowModal(false);
        if (action == true) setGuardadoExitoso(true);
    }

    const onChangeUnidadEconomica = (inputValue) => {
        setUnidadEconomica(inputValue);
    }

    const getOptionValue = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value == idDefault)
    }

    const animatedComponents = makeAnimated();

    const colorList = [
        "#ff455a",
        "#434df4"
    ];
    const settings = {
        "disableTooltipX": false,
        "disableTooltipY": false,
        "disableLabelX": false,
        "disableLabelY": false,
        "tooltipDy": 0,
        "tooltipAft": "",
        "enableBullet": true,
        "enableLegend": true,
        "circleBulletRadius": "5",
        "widthColumn": 50,
        "strokeWidth": 2,
        "timeTotalAnimation": 20,
        "exportar": true,
        "titleY": ``,
        "titleX": "Years",
        "labelAdapterAxisY": ""
    }

    const dataSeries = [
        {
            "name": "Ventas",
            "field": "montoVentas",
            "tooltipPrev": "S/ ",
            "tooltipAft": ""
        }
    ];

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.BITACORA_EVENTOS]} >
                <PageTitle>{title}</PageTitle>
                <div className="card my-5">
                    <div className="card-body tab-content pt-0 my-5">
                        <div className="row g-3 g-xl-4 flex-wrap d-flex flex-row">
                            <div className="col-12 col-md-6 col-lg-2" >
                                <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                                <Select
                                    classNamePrefix='filter'
                                    components={animatedComponents}
                                    defaultValue={getOptionValue(0)}
                                    isMulti={false}
                                    closeMenuOnSelect={true}
                                    options={unidadesEconomicasList.list}
                                    onChange={(onChangeUnidadEconomica)}
                                />
                            </div>
                            <div className='col-12 col-md-6 col-lg-4 '>
                                <div className="fw-bold fs-7 text-gray-600 mb-1">Fecha Inicio:</div>
                                <DatePicker
                                    className="form-control form-control-transparent pe-5"
                                    locale="es"
                                    value={date1}
                                    onChange={(dateX) => { if (dateX) if (dateX <= date2) return setDate1(dateX); }}
                                    format="dd/MM/yyyy"
                                    minDate={Utilities.add_years(new Date(), -6)}
                                    maxDate={new Date()}
                                />
                            </div>
                            <div className='col-12 col-md-6 col-lg-4 '>
                                <div className="fw-bold fs-7 text-gray-600 mb-1">Fecha Fin:</div>
                                <DatePicker
                                    className="form-control form-control-transparent pe-5"
                                    locale="es"
                                    value={date2}
                                    onChange={(dateX) => { if (dateX) if (dateX >= date1) return setDate2(dateX); }}
                                    format="dd/MM/yyyy"
                                    minDate={Utilities.add_years(new Date(), -6)}
                                    maxDate={new Date()}
                                />
                            </div>
                            {(unidadEconomica.value !== '0') &&
                                <div className='col-12 col-md-6 col-lg-2 '>
                                    <div className="fw-bold fs-7 text-gray-600 mb-1">Agregar Evento</div>
                                    <button className="btn bg-light-blue btn-sm" onClick={() => setShowModal(true)}><span className='text-blue fw-bold '>Agregar<i className="fi-rr-plus-small text-blue fw-bold"></i></span></button>
                                    {showModal && <BitacoraEvento_Agregar setSmShow={onAfterGuardar} unidadEconomica={unidadEconomica.value}></BitacoraEvento_Agregar>}
                                </div>
                            }
                        </div>
                        <div className='row mt-4'>
                            <div className="col-12">
                                <div className="text-dark  fw-bolder fs-3 text-left text-center">Venta Acumulada  </div>
                                <div className="fw-bolder fs-3 text-primary text-center">S/ {Utilities.comillasFix(dataAux.ventaAcumlada, true)}</div>
                            </div>
                        </div>
                        <ChartFromServer
                            apiService={Api.BitacoraDiariaVentas}
                            setAuxData={setDataAux}
                            args={{ unidadEconomica: unidadEconomica.value, fechaInicio: dateFormated, fechaFin: dateFormated2, token: token }}
                            conditions={true}
                            type="AreaChart"
                            idContent="Bitacora_Diaria_Ventas"
                            dataSeries={dataSeries}
                            colorList={colorList}
                            settings={settings}
                            classContent="chart400Height"
                            setEnableQuery={setEnableQuery}
                            initialDate={date1}
                            endDate={date2}
                        >
                        </ChartFromServer>
                    </div>
                </div>
                <Modal
                    size="sm"
                    show={guardadoExitoso}
                    onHide={() => setGuardadoExitoso(false)}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title id="example-modal-sizes-title-sm" style={{ margin: 'auto' }}>
                            Guardado Exitoso
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Footer style={{ margin: 'auto' }}>
                        <button type="button" className="btn btn-primary" onClick={() => window.location.reload(false)}>
                            Aceptar
                        </button>
                    </Modal.Footer>
                </Modal>
            </PermissionsGate>
        </>

    )
}